<div class="w-full h-full grid grid-cols-1 content-center">
    <div class="flex justify-center w-full md:mt-11 pb-8" *ngIf="!loading">
        <img *ngIf="postbackData.result === '-1' && !userCancelled || userCancelled" src="assets/icons/Icons/transaction-fail.png" alt="transaction fail">
        <img *ngIf="result && !userCancelled" src="assets/icons/Icons/transaction-success-green.png" alt="transaction success">
    </div>
    <div class="flex justify-center pt-4 pb-6" *ngIf="!loading">
        <p class="text-xl w-100 text-center m-0" *ngIf="result && !userCancelled">
            Transaction Successful
        </p>
        <div class="text-center" *ngIf="postbackData.result === '-1' && !userCancelled || userCancelled">
          <div class="w-full" *ngIf="postbackData.result === '-1' && !userCancelled">
            <p class="text-xl w-100 text-center m-0">
              Transaction Failed
            </p>
          </div>
          <div class="w-full" *ngIf="userCancelled">
            <p class="text-xl w-100 text-center m-0">
              Transaction Cancelled
            </p>
            <p class="w-100 text-center text-lg my-3" *ngIf="errorMessage"> {{errorMessage}}</p>
          </div>
        </div>
        <p class="subtext w-full text-center" *ngIf="postbackData.isShopifyTransaction && postbackData.url == null">Your Transaction has been processed, however we were unable to update Shopify with the transaction status. We will continue to try and update Shopify in the background! In the meantime you may close this tab.</p>

        <form novalidate="novalidate" name="post" [action]="postbackData.url" #form id="form"  [method]="postbackData.redirectMethod" [attr.target]="postbackData.redirectFrameTarget || null"  *ngIf="postbackData">
            <input
              *ngFor="let formEle of postbackData.formElements | keyvalue"
              type="hidden"
              [id]="formEle.key"
              [name]="formEle.key"
              [value]="formEle.value"
            />
        </form>
    </div>
    <div class="grid grid-cols-1 pt-4 pb-8" *ngIf="loading || loadingRedirect">
        <h3 class="text-center my-8" *ngIf="loading && postbackData"><b>Confirming your transaction...</b></h3>
        <h3 class="text-center my-8" *ngIf="loading && !postbackData"><b>Getting your transaction details...</b></h3>
        <div class="flex justify-center" *ngIf="!postbackData || postbackData.url">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>
